module.exports = __webpack_public_path__ + "img/image8.a28235a2.png";